<template>
    <b-card class="shadowed p-2 h-100" body-class="px-1 px-md-3">
        <div class="d-flex">
            <multi-circle />
            <div>
                <small class="font-weight-bold">
                    {{ title }}
                </small>
                <h6>
                    {{ description }}
                </h6>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-end mt-1" v-if="date">
            <small class="mb-2">
                🗓️ {{ date }}
            </small>
        </div>
        <div class="d-flex align-items-center justify-content-end">
            <b-button
                :variant="secondaryButtonVariant"
                @click="$emit('secondaryClicked')"
                v-if="secondaryButtonText"
                class="mr-2 font-weight-bold"
                size="sm"
            >{{ secondaryButtonText }}
            </b-button>
            <b-button
                :variant="buttonVariant"
                @click="$emit('primaryClicked', resultId)"
                size="sm"
            >{{ buttonText }}
            </b-button>
        </div>
    </b-card>
</template>

<script>
    import MultiCircle from "../../atoms/MultiCircle";

    export default {
        name: "MultiMeResultCard",
        components: {MultiCircle},
        props: {
            title: String,
            description: String,
            buttonText: String,
            buttonVariant: String,
            secondaryButtonText: String,
            secondaryButtonVariant: String,
            date: String,
            resultId: Number,
        },
    }
</script>